import { getAutoStartStreamsConfig } from "../../lib/runtimeConfig";

/**
 * How many cameras a wall lights up on its own when it opens.
 *
 * Eight is a wall that shows something useful the moment it is opened, without
 * committing a site's whole uplink to cameras nobody has asked for. It is the
 * middle of two failure modes that both showed up in practice: starting
 * everything spent the entire link on a page load, and starting nothing left an
 * operator facing a grid of dark tiles they had to click through one by one.
 *
 * Which eight is the top of the list the operator is already looking at —
 * name-ordered, and narrowed by whatever site or recorder they have selected.
 * That ordering matters beyond tidiness: every screen viewing the same scope
 * picks the SAME eight, and the server keeps one RTSP session per camera and
 * shares it, so a room full of screens showing the same wall costs the site
 * link one set of streams rather than one set per screen.
 *
 * Zero disables auto-start entirely, for a deployment that would rather every
 * stream be asked for.
 */
export const DEFAULT_AUTO_START_STREAMS = 8;

export function getAutoStartStreams(): number {
  const raw = getAutoStartStreamsConfig();
  if (raw === undefined || raw.trim() === "") return DEFAULT_AUTO_START_STREAMS;
  const parsed = Number.parseInt(raw, 10);
  // Zero is a legitimate setting ("nothing starts by itself"), so it is
  // accepted here where the slot budget rejects it — that one treats zero as a
  // misconfiguration because a limit of zero would make the wall unusable.
  if (!Number.isFinite(parsed) || parsed < 0) return DEFAULT_AUTO_START_STREAMS;
  return parsed;
}
